<div class="row ss-top-menu">
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
    <span class="ss-text-light ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/']">Dashboard</span> 
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-light ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/community_manager/leads']" [queryParams]="query_params" *ngIf="role=='community_manager'">Lead</span>
    <span class="ss-text-light ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/designer/leads']" [queryParams]="{customer_status: lead_details.lead_status}" *ngIf="role=='designer'">Lead </span>
    <span *ngIf="lead_details" class="capitalize" style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> {{lead_details.lead_status | replaceChar}}</span>
    <span style="vertical-align: -webkit-baseline-middle;" *ngIf="lead_details && lead_details.user_reference"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark capitalize" style="vertical-align: -webkit-baseline-middle;" *ngIf="lead_details && lead_details.user_reference">{{lead_details.user_reference.name}}</span>
  </div>
</div>
<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="row px-4">
  <app-shared-top-menu [lead_id]='lead_id' [lead_details]='lead_details' [lead_status]='lead_status' [basic_info_tab]='"active"'></app-shared-top-menu>
  <div class="col-12 bg-white my-3 pt-3 mt-lg-0 pt-lg-5 mb8">
    <div class="row">
      <div class="col-md-12">
        <div class="phone pull-right">
          <i class="fa fa-phone cursor-pointer" (click)="callToLead(lead_details.id)" style="    font-size: 1.5rem; color: #8F0020;"></i>
        </div>
        
        
      </div>
      
    </div>
    <div class="row mb-lg-5">
      <div class="col-md-4">
        <div class="form-group">
          <label for="exampleFormControlInput1" class="ss-form-label">Lead Name</label>
          <input type="email" class="form-control ss-form-control" id="exampleFormControlInput1" value="{{lead_details.name}}" readonly>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label for="exampleFormControlInput1" class="ss-form-label">Project Name</label>
          <input type="email" class="form-control ss-form-control" id="exampleFormControlInput1" value="{{lead_details.project_details.name}}" readonly>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label for="exampleFormControlInput1" class="ss-form-label">Email</label>
          <input type="email" class="form-control ss-form-control" id="exampleFormControlInput1" value="{{lead_details.email}}" readonly>
        </div>
      </div>

      <div class="col-md-4" *ngIf="!(role=='designer') ">
        <div class="form-group">
          <label for="exampleFormControlInput1" class="ss-form-label">Contact</label>
          <input type="email" class="form-control ss-form-control" id="exampleFormControlInput1" value="{{lead_details.contact}}" readonly>
        </div>
      </div>

      <!-- <div class="col-md-4">
        <div class="form-group">
          <label for="exampleFormControlInput1" class="ss-form-label">City</label>
          <input type="email" class="form-control ss-form-control" id="exampleFormControlInput1" value="{{lead_details.city}}" readonly>
        </div>
      </div> -->

    </div>
  </div>
</div>





// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/lead/basic-info/basic-info.component.html